import { MutableRefObject, useEffect, useRef } from 'react';

export default function useForwardedRef<T>(
  forwardedRef:
    | ((instance: T | null) => void)
    | React.MutableRefObject<T | null>
    | null
) {
  const innerRef = useRef<T>(null);

  useEffect(() => {
    if (!forwardedRef) return;

    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current);
    } else {
      forwardedRef.current = innerRef.current;
    }
  }, [innerRef, forwardedRef]);

  return innerRef as MutableRefObject<T>;
}
